<script>
	// Saved goods-return certificates: agents see their own, the admin sees everyone's.
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import fetchData from '../../api.js';
	import UserStore from '../../stores/user';
	import { money, formatDate } from '../../lib/format';
	import AppShell from '../../components/AppShell.svelte';
	import Icon from '../../components/Icon.svelte';

	let notes = [];
	let loading = true;
	let q = '';

	$: isAdmin = $UserStore.role === 'admin';
	$: shown = notes.filter((n) => !q || (n.customer_name || '').includes(q) || String(n.id) === q.trim() || (n.agent_name || '').includes(q));

	onMount(async () => {
		if (!$UserStore || !$UserStore.data) {
			push('/login');
			return;
		}
		const res = await fetchData({ action: 'agents_return_notes', token: $UserStore.data });
		notes = (res && res.data) || [];
		loading = false;
	});
</script>

<AppShell title="תעודות החזרה">
	<div class="top">
		<p class="muted">תעודות החזרת סחורה מלקוחות. נשמרות בתוכנה בלבד ולא נשלחות לווריפון.</p>
		<button class="btn-primary" on:click={() => push('/agents/return-notes/new')}><Icon name="plus" size={20} /> תעודה חדשה</button>
	</div>

	{#if loading}
		<div class="spinner" />
	{:else if !notes.length}
		<div class="empty-state"><b>אין עדיין תעודות החזרה</b>לוחצים "תעודה חדשה", בוחרים לקוח ומסמנים את הדגמים שהוא מחזיר.</div>
	{:else}
		<label class="search small"><input type="search" placeholder="חיפוש לקוח או מספר תעודה" bind:value={q} /></label>
		{#if !shown.length}
			<div class="empty-state"><b>אין תעודות שמתאימות לחיפוש</b></div>
		{:else}
			<div class="table">
				<div class="head"><span>מס׳ תעודה</span><span>לקוח</span><span>תאריך</span><span>יחידות</span><span>קרטונים</span><span>לפני מע״מ</span></div>
				{#each shown as n (n.id)}
					<button class="row" on:click={() => push('/agents/return-notes/' + n.id)}>
						<span class="num">{n.id}</span>
						<span class="name">{n.customer_name}{#if isAdmin}<small class="muted agent">{n.agent_name || ''}</small>{/if}</span>
						<span class="muted">{formatDate(n.created_at)}</span>
						<span>{Number(n.units) || 0}</span>
						<span>{Number(n.cartons) || '—'}</span>
						<span class="money">{money(Math.round(Number(n.total) * 100) / 100)}</span>
					</button>
				{/each}
			</div>
		{/if}
	{/if}
</AppShell>

<style>
	.top { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 16px; flex-wrap: wrap; }
	.top p { margin: 0; }
	.search.small { max-width: 380px; margin-bottom: 14px; background: var(--surface); }
	.table { display: block; background: var(--surface); border: 1px solid var(--line); border-radius: var(--radius); overflow: hidden; }
	.head, .row { display: grid; grid-template-columns: 100px 1fr 160px 80px 90px 130px; gap: 12px; align-items: center; padding: 0 20px; }
	.head { height: 48px; color: var(--muted); font-size: 14px; border-bottom: 1px solid var(--line); }
	.row { width: 100%; min-height: 64px; border: 0; border-bottom: 1px solid var(--line); background: none; text-align: start; font-size: 17px; }
	.row:last-child { border-bottom: 0; }
	.row:active { background: var(--bg); }
	.num { font-weight: 800; }
	.name { font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.agent { display: block; font-size: 13px; font-weight: 400; }
	.money { font-weight: 700; }
	@media (max-width: 1000px) {
		.head, .row { grid-template-columns: 70px 1fr 80px 110px; }
		.head span:nth-child(3), .head span:nth-child(4), .row span:nth-child(3), .row span:nth-child(4) { display: none; }
	}
</style>
